const routes = {
    home: {
        route: '/',
        name: 'Home'
    },

    movies: {
        route: '/movies',
        name: 'Movies'
    },

    series: {
        route: '/series',
        name: 'Series'
    },

    people: {
        route: '/people',
        name: 'People'
    },
};

export default routes;